import React from "react";
import { useTranslation } from "react-i18next";
import FeedbackModal from "../feedback/FeedbackModal";

const ModalNoPAP = ({ show, onHide, confirmDescription }) => {
  const { t } = useTranslation();

  return (
    <FeedbackModal
      show={show}
      onHide={onHide}
      severity="warning"
      title={t("No PAP Direction")}
      message={
        confirmDescription
          ? t(confirmDescription)
          : t("PAP Direction Required")
      }
    />
  );
};

export default ModalNoPAP;
